import React from "react";

import envs from "config/envs";

import * as S from "./HomeContact.style";

const HomeContact = () => {
  return (
    <S.ContactContainer>
      <S.SectionTitle variant="headline-02" fontSize="40px" color="primary">
        Encontre a CNP Seguros Holding Brasil
      </S.SectionTitle>
      <S.Initiative>
        <S.InitiativeImage
          width="auto"
          height="auto"
          src={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/contact_home.webp`}
        />
        <S.InitiativeContent>
          <S.InitiativeContentTitle variant="headline-03" fontSize="24px">
            Onde estamos
          </S.InitiativeContentTitle>
          <S.InitiativeContentDescription variant="body02-sm" color="primary">
            SHN Quadra 1, Conjunto A, Bloco E <br />
            Asa Norte, Brasília/DF <br />
            CEP: 70701-050
          </S.InitiativeContentDescription>
        </S.InitiativeContent>
      </S.Initiative>
    </S.ContactContainer>
  );
};

export default HomeContact;
